var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.223,
    height: 90.28,
    viewBox: "0 0 43.223 90.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.874,18.176a18.9,18.9,0,0,1,.687-2.578c.3-.819.674-1.518,1.094-1.518,1.017,0-3.561-4.353-3.561-4.353s-.287.538-.763,1.262a17.853,17.853,0,0,1-1.139,1.562,8.529,8.529,0,0,1-1.913,1.785C22.244,15.615,29.874,18.176,29.874,18.176Z",
    transform: "translate(-9.983 -4.057)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.316,53.341s10.2,6.487,7.057,7.553-8.349-6.556-8.349-6.556Z",
    transform: "translate(-22.951 -22.249)",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.026,27.937s4.885,3.586,6.313,6.314,8.85,8.79,8.85,8.79-1.532,3.048-2.273,2.864S26.9,34.282,25.293,33.356,26.135,26.708,30.026,27.937Z",
    transform: "translate(-10.342 -11.581)",
    fill: "#004ca6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.834,39.158S69.28,43,66.482,44.791s-9.666-4.353-9.666-4.353Z",
    transform: "translate(-23.699 -16.333)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.183,128.732s4.833-2.048,4.324,1.024-2.8,5.889-2.8,7.425-4.324,4.865-5.087,4.1,1.272-3.841.763-5.633a57.451,57.451,0,0,1-1.017-5.889Z",
    transform: "translate(-16.421 -53.417)",
    fill: "#55536e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.183,128.732s4.833-2.048,4.324,1.024-2.8,5.889-2.8,7.425-4.324,4.865-5.087,4.1,1.272-3.841.763-5.633a57.451,57.451,0,0,1-1.017-5.889Z",
    transform: "translate(-16.421 -53.417)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.558,132.686s4.833-2.049,4.324,1.024-2.8,5.889-2.8,7.425S37.76,146,37,145.233s1.272-3.841.763-5.634a57.447,57.447,0,0,1-1.017-5.889Z",
    transform: "translate(-15.326 -55.066)",
    fill: "#55536e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.064,101.1s15.007,14.339,14.5,15.619-3.815,4.1-3.815,4.1S23.3,105.706,24.064,101.1Z",
    transform: "translate(-10.022 -42.169)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.064,101.1s15.007,14.339,14.5,15.619-3.815,4.1-3.815,4.1S23.3,105.706,24.064,101.1Z",
    transform: "translate(-10.022 -42.169)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.48,56.322s3.815,3.841,2.8,11.266.763,14.6,2.8,16.9S26.5,100.106,26.5,100.106s-3.561,5.889-6.359,2.817S8.954,87.3,8.954,87.3,1.324,72.2.561,68.1-.457,57.6,1.578,56.322,10.48,56.322,10.48,56.322Z",
    transform: "translate(0 -23.255)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,11.247a19.943,19.943,0,0,1,4.5,1.385c.01-.031.02-.056.031-.082.28-.671.455.21.86.21,1.017,0-3.561-4.353-3.561-4.353s-.173.323-.471.807c-.089.141-.186.294-.292.456-.089.136-.186.279-.287.428Z",
    transform: "translate(-12.015 -3.507)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.595,12.427a4.865,4.865,0,1,0-4.833-4.865A4.849,4.849,0,0,0,34.595,12.427Z",
    transform: "translate(-12.414 -1.125)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.679,17.193s7.376.768,8.9,4.1S13.17,40.75,12.407,41.006.961,42.542.961,42.542,1.47,26.155,11.39,20.01C11.39,20.01,13.679,18.986,13.679,17.193Z",
    transform: "translate(-0.401 -7.172)",
    fill: "#0d71e8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8,20.263s5.6,2.3,7.631,4.609,10.683,6.4,10.683,6.4S44.347,34.6,43.584,34.6,25.271,27.176,23.49,26.664,22.727,20.007,26.8,20.263Z",
    transform: "translate(-9.447 -8.449)",
    fill: "#0d71e8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.307,7.077s1.272-1.28-1.272-2.3c0,0,2.544-1.024,3.052-2.561s2.289-4.1,3.815,0,4.324,9.474-4.833,9.474c0,0-2.289.512-2.289-1.536a3.849,3.849,0,0,1,1.526-3.073Z",
    transform: "translate(-14.508 0)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople01);
export default __webpack_public_path__ + "static/media/people01.a6ab37619b7d534a37be305648e0e13d.svg";
export { ForwardRef as ReactComponent };